export default class Brand {
  constructor(data = {}) {
    this.id = data.id || '';
    this.name = data.name || '';
    this.createdAt = data.createdAt || null;
    this.updatedAt = data.updatedAt || null;
  }

  get isValid() {
    return this.name && this.name.trim() !== '';
  }

  get displayName() {
    return this.name || 'Thương hiệu mới';
  }

  toJSON() {
    return {
      id: this.id,
      name: this.name,
    };
  }

  static fromApiResponse(data) {
    return new Brand({
      id: data.id,
      name: data.name,
      createdAt: data.created_at ? new Date(data.created_at) : null,
      updatedAt: data.updated_at ? new Date(data.updated_at) : null,
    });
  }

  static fromApiResponseArray(dataArray) {
    return dataArray.map((item) => Brand.fromApiResponse(item));
  }
}
